module.exports = __webpack_public_path__ + "static/media/sort_icon.83b3fc31.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/icons/sort_icon.svg
// module id = 327
// module chunks = 2